var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.id !== 'account')?[_c('i',{staticClass:"md-icon vsm--icon"},[_vm._v(_vm._s(_vm.icon))])]:[_c('i',{staticClass:"md-icon",on:{"click":_vm.logout}},[_vm._v("exit_to_app")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }